module.exports = __webpack_public_path__ + "img/logo-farmacias.webp";